import { Axios } from "../../service/serviceBasic";
import {
  converterListActionForListReduceDropdownDadosTipoContaDadosBancario,
  converterListActionBancoParaListaComNomeCodigo,
} from "../../helper/converter";

import {
  HANDLE_CHANGE_DADOS_BANCO,
  LOADING_DADOS_INICIAIS_DADOS_BANCARIOS,
  SET_DADOS_INICIAIS_DADOS_BANCARIOS,
  ERROR_DADOS_INICIAIS_DADOS_BANCARIOS,
  CHANGE_DADOS_INICIAIAS_DADOS_BANCARIOS_VALUE_FORM,
  HANDLE_CHANGE_DADOS_TIPO_CONTA,
  SET_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,
  LOADING_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,
  ERROR_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,
  SET_DADOS_INICIAIS_DADOS_TYPEHEADER_BANCO,
} from "./types";

export const handleChangeDadosBanco = (event) => ({
  type: HANDLE_CHANGE_DADOS_BANCO,
  payload: event.value,
});

export const handleChangeDadosTipoConta = (event) => ({
  type: HANDLE_CHANGE_DADOS_TIPO_CONTA,
  payload: event.value,
});

export const loadingListDadosBancoAction = (flag) => ({
  type: LOADING_DADOS_INICIAIS_DADOS_BANCARIOS,
  payload: flag,
});

export const loadingListTipoContaAction = (flag) => ({
  type: LOADING_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,
  payload: flag,
});

export const setListDadosBancoAction = (data) => ({
  type: SET_DADOS_INICIAIS_DADOS_BANCARIOS,
  payload: data,
});

export const setListTipoContaAction = (data) => ({
  type: SET_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,
  payload: data,
});

export const errorListDadosBancoAction = (message) => ({
  type: ERROR_DADOS_INICIAIS_DADOS_BANCARIOS,
  payload: message,
});

export const errorListTipoContaAction = (message) => ({
  type: ERROR_DADOS_INICIAIS_TIPO_CONTA_BANCARIA,
  payload: message,
});

export const setTypeHeaderBancoList = (data) => ({
  type: SET_DADOS_INICIAIS_DADOS_TYPEHEADER_BANCO,
  payload: data,
});

export const changeDadosIniciaisDadosBancariosValueForm = (name, value) => (
  dispatch,
  getState
) => {
  let { dadosBancarioReducer } = getState();
  let formDadosBancarios = dadosBancarioReducer.formDadosBancarios;

  formDadosBancarios[name] = value;

  dispatch({
    type: CHANGE_DADOS_INICIAIAS_DADOS_BANCARIOS_VALUE_FORM,
    payload: formDadosBancarios,
  });
};

export const listDadosBancoAction = () => (dispatch) => {
  dispatch(loadingListDadosBancoAction(true));
  return Axios.post("v1/basico/banco/list")
    .then((response) => {
      dispatch(setListDadosBancoAction(response.data));
      dispatch(
        setTypeHeaderBancoList(
          converterListActionBancoParaListaComNomeCodigo(response.data)
        )
      );
    })
    .catch((error) => {
      dispatch(errorListDadosBancoAction(error.message));
    })
    .finally(() => {
      dispatch(loadingListDadosBancoAction(false));
    });
};

export const listTipoContaAction = () => (dispatch) => {
  dispatch(loadingListTipoContaAction(true));
  return Axios.post("v1/basico/tipoconta/list")
    .then((response) => {
      dispatch(
        setListTipoContaAction(
          converterListActionForListReduceDropdownDadosTipoContaDadosBancario(
            response.data
          )
        )
      );
    })
    .catch((error) => {
      dispatch(errorListTipoContaAction(error.message));
    })
    .finally(() => {
      dispatch(loadingListTipoContaAction(false));
    });
};
